module.exports = __webpack_public_path__ + "static/avatar-06753b7bb5ebf7f928eb20cf813825d5.svg";